export default (props) => {
    if (props.device === 'mobile') {
        return (
            <div className="ad-footer">
                <div className="spot">
                    <iframe className="na" frameBorder="0" scrolling="no" width="300" height="250"
                            sandbox="allow-scripts allow-popups allow-forms allow-same-origin"
                            src="//a.o333o.com/api/spots/53910?p=1"/>
                </div>

            </div>)
    }
    return (
        <div className="ad-footer">
            <div className="spot">
                <iframe className="na" frameBorder="0" scrolling="no" width="300" height="250"
                        src="//a.o333o.com/api/spots/53910?p=1"/>
            </div>
            <div className="spot">
                <iframe className="na" frameBorder="0" scrolling="no" width="300" height="250"
                        src="//a.o333o.com/api/spots/53911?p=1"/>
            </div>
            <div className="spot">
                <iframe className="na" frameBorder="0" scrolling="no" width="300" height="250"
                        src="//a.o333o.com/api/spots/53912?p=1"/>
            </div>
            <div className="spot">
                <iframe className="na" frameBorder="0" scrolling="no" width="300" height="250"
                        src="//a.o333o.com/api/spots/53913?p=1"/>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// components/ads/Footer.js